"use client";

import { useState } from "react";
import DownloadApp from "../assets/icons/Download-App.svg?react";
import AppDownloadPopup from "./Popup/AppDownloadPopup";

export default function WelcomeBanner() {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      <div className="relative flex items-center mt-3.5 px-5 max-xs:mt-0.5 ">
        {/* Slider Section */}
        <div className="flex-1 overflow-hidden bg-white rounded-full px-4 py-2 max-xs:py-1 ">
          <div className="whitespace-nowrap animate-slide text-sm px-2 max-xs:text-xs">
            {" "}
            {/* Added padding */}
            Welcome to PCSO E-Lotto | Download our App for a better experience! Welcome to PCSO E-Lotto | Download our App for a better experience!
          </div>
        </div>

        {/* Image Section */}
        <div className="ml-2">
          {/* <img
          src={downloadApp}
          alt="Download App"
          className="h-8 w-auto object-contain animate-zoom" // Added animation class
          onClick={() => setShowPopup(true)}
        /> */}
          <DownloadApp
            className="h-8 max-xs:h-6 w-auto object-contain animate-zoom" // Added animation class
            onClick={() => setShowPopup(true)}
          />
        </div>
      </div>

      <AppDownloadPopup
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
      />
    </>
  );
}
